import { ContentPage } from '../page-factory/content-page';
import { paushPurnimaPage } from '../pages/page-magh-mela.bathing-dates';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Paush Purnima - Magh Mela 2026 - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Learn about Paush Purnima, the auspicious full moon day marking the start of Magh Mela 2026. Book your spiritual journey with Kumbh Sukrit.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026/paush-purnima',
    },
  ];
};

export default function PaushPurnimaPage() {
  return <ContentPage {...paushPurnimaPage} />;
}
